/* DSL Postcode validation per country */
(function(){
  var PATTERNS = {
    NL: /^\d{4}\s?[A-Z]{2}$/i,
    BE: /^\d{4}$/,
    DE: /^\d{5}$/,
    FR: /^\d{5}$/,
    GB: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i
  };
  document.addEventListener("blur", function(e){
    if (!e.target.matches("input[name*=zip],input[name*=postal_code]")) return;
    var country = (document.querySelector("select[name*=country]") || {}).value || "NL";
    var p = PATTERNS[country];
    if (!p) return;
    e.target.classList.toggle("dsl-invalid-pc", !p.test(e.target.value.trim()));
  }, true);
})();